export default "/images/user-minus.svg?f0dcd6e950df9c053462173a7953d870";